import styles from "./News.module.scss";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import getRequest from "../../../../helpers/getRequest";
const News = ({ currentLang }) => {
  const [news, setNews] = useState([]);
  const { t } = useTranslation();
  useEffect(() => {
    try {
      getRequest(`v1/articles`, null, currentLang.lang).then(
        async (response) => {
          const data = await response.data;
          // Get only the most recent article
          setNews(data.articles.slice(0, 3));
        }
      );
    } catch (err) {
      console.log(err);
    }
  }, [currentLang]);

  return (
    <section className={styles.news}>
      <div className="container">
        <h2>{t("Recent news")}</h2>
        <div className={styles.news__grid}>
          {news &&
            news.length !== 0 &&
            news.map((n, i) => (
              <div className={styles.card} key={n.id}>
                <a href={`/news/${n.id}`}>
                  <div
                    className={styles.card__main}
                    style={{
                      backgroundImage: `url(${n.image})`,
                      backgroundSize: "cover",
                    }}
                  ></div>
                  <div className={styles.card__overlay}>
                    <h5>{n.title}</h5>
                    <p
                      dangerouslySetInnerHTML={{ __html: n.title + "..." }}
                    ></p>
                    <span>
                      {currentLang.lang == "EN"
                        ? new Date(n.created_at).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })
                        : new Date(n.created_at).toLocaleDateString("de-DE", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })}
                    </span>
                  </div>
                </a>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default News;
